var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 850.39 850.39",
    viewBox: "0 0 850.39 850.39",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\u5716\u5C64_1",
    display: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\u5716\u5C64_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m466.12 379.87c0 11.42 9.73 38.77 14.45 51.34.94 2.52-1.51 4.97-4.03 4.03-12.58-4.72-39.92-14.45-51.34-14.45s-38.77 9.73-51.34 14.45c-2.52.94-4.97-1.51-4.03-4.03 4.72-12.58 14.45-39.92 14.45-51.34s-9.73-38.77-14.45-51.34c-.94-2.52 1.51-4.97 4.03-4.03 12.58 4.72 39.92 14.45 51.34 14.45s38.77-9.73 51.34-14.45c2.52-.94 4.97 1.51 4.03 4.03-4.72 12.57-14.45 39.91-14.45 51.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.13 350.93c8.08 8.08 34.29 20.53 46.52 26.09 2.45 1.11 2.45 4.59 0 5.7-12.23 5.56-38.44 18.01-46.52 26.09s-20.53 34.29-26.09 46.52c-1.11 2.45-4.59 2.45-5.7 0-5.56-12.23-18.01-38.44-26.09-46.52s-34.29-20.53-46.52-26.09c-2.45-1.11-2.45-4.59 0-5.7 12.23-5.56 38.44-18.01 46.52-26.09s20.53-34.29 26.09-46.52c1.11-2.45 4.59-2.45 5.7 0 5.57 12.22 18.02 38.44 26.09 46.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m437.51 227.47c3.44 3.44 14.59 8.73 19.79 11.1 1.04.47 1.04 1.95 0 2.42-5.2 2.36-16.35 7.66-19.79 11.1s-8.73 14.59-11.1 19.79c-.47 1.04-1.95 1.04-2.42 0-2.36-5.2-7.66-16.35-11.1-19.79s-14.59-8.73-19.79-11.1c-1.04-.47-1.04-1.95 0-2.42 5.2-2.36 16.35-7.66 19.79-11.1s8.73-14.59 11.1-19.79c.47-1.04 1.95-1.04 2.42 0 2.36 5.2 7.66 16.35 11.1 19.79z",
    stroke: "#000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m437.51 507.65c3.44 3.44 14.59 8.73 19.79 11.1 1.04.47 1.04 1.95 0 2.42-5.2 2.36-16.35 7.66-19.79 11.1s-8.73 14.59-11.1 19.79c-.47 1.04-1.95 1.04-2.42 0-2.36-5.2-7.66-16.35-11.1-19.79s-14.59-8.73-19.79-11.1c-1.04-.47-1.04-1.95 0-2.42 5.2-2.36 16.35-7.66 19.79-11.1s8.73-14.59 11.1-19.79c.47-1.04 1.95-1.04 2.42 0 2.36 5.2 7.66 16.35 11.1 19.79z",
    stroke: "#000",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m425.2 735.62c-5.2 0-10.39-1.25-15.13-3.76l-166.01-87.89c-10.61-5.62-17.21-16.57-17.21-28.58v-485.62c0-8.28 6.72-15 15-15h366.7c8.28 0 15 6.72 15 15v485.62c0 12.01-6.59 22.96-17.21 28.58l-166.01 87.89c-4.74 2.51-9.94 3.76-15.13 3.76zm-168.35-590.85v470.62c0 .87.48 1.66 1.24 2.07l166.01 87.89c.69.36 1.5.36 2.19 0l166.01-87.89c.77-.41 1.24-1.2 1.24-2.07v-470.62z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminAvatar);
export default __webpack_public_path__ + "static/media/admin_avatar.b7a51fa0649b90f3df1ae93cb7937915.svg";
export { ForwardRef as ReactComponent };